// extracted by css-extract-rspack-plugin
export default {"ConfirmMergeContainer":"ConfirmMerge-module__ConfirmMergeContainer__qIxQhcb","ConfirmMergeText":"ConfirmMerge-module__ConfirmMergeText__LjWK7kB"};